module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/wave_top-08a89fdce62eeef7d7685cd6e2ce9044.png";